export const messages = {
  en: {
    editShopSmsSwitch: {
      title: 'Edit SMS Switch',
      smsSwitch: 'SMS Switch',
      enable: 'Enable',
      disable: 'Disable',
      save: 'Save',
      cancel: 'Cancel',
      saveSuccess: 'SMS switch updated successfully',
      saveFailed: 'Failed to update SMS switch'
    }
  },
  zh: {
    editShopSmsSwitch: {
      title: '编辑短信开关',
      smsSwitch: '短信开关',
      enable: '启用',
      disable: '禁用',
      save: '保存',
      cancel: '取消',
      saveSuccess: '短信开关更新成功',
      saveFailed: '短信开关更新失败'
    }
  }
} 